import { render, staticRenderFns } from "./MainContainerSecondContents.vue?vue&type=template&id=55cc71aa&scoped=true&"
import script from "./MainContainerSecondContents.vue?vue&type=script&lang=js&"
export * from "./MainContainerSecondContents.vue?vue&type=script&lang=js&"
import style0 from "./MainContainerSecondContents.vue?vue&type=style&index=0&id=55cc71aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cc71aa",
  null
  
)

export default component.exports